import script from "./MenuAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuAnimation.vue?vue&type=script&setup=true&lang=js"

import "./MenuAnimation.vue?vue&type=style&index=0&id=65e8233e&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e8233e"]])

export default __exports__